<template>
  <div class="sidebar sidebar-img"
       :data-active-color="activeColor">
    <div class="logo">
       <img class="logo-mods logo-normal" :src="logo" alt="">
       <img class="logo-mods logo-mini" :src="logoMini" alt="">
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot>

      </slot>
      <ul class="nav">
        <slot name="links">
          <sidebar-item v-for="(link, index) in userLinks"
                        :key="link.name + index"
                        :link="{...link, name: $t(link.name)}">

            <sidebar-item v-for="(subLink, index) in link.children"
                          :key="subLink.name + index"
                          :link="{...subLink, name: $t(subLink.name)}">
            </sidebar-item>
          </sidebar-item>
        </slot>
      </ul>
      <ul class="nav admin-links">
        <slot name="admin-links">
          <sidebar-item v-for="(link, index) in adminLinks"
                        :key="link.name + index"
                        :link="{...link, name: $t(link.name)}">
            <sidebar-item v-for="(subLink, index) in link.children"
                          :key="subLink.name + index"
                          :link="{...subLink, name: $t(subLink.name)}">
            </sidebar-item>
          </sidebar-item>
        </slot>
      </ul>
    </div>
  </div>
</template>
<script>
  import 'perfect-scrollbar/dist/css/perfect-scrollbar.css'
  export default {
    props: {
      title: {
        type: String,
        default: 'TeamWave',
        description: 'Sidebar title'
      },
      backgroundColor: {
        type: String,
        default: 'black',
        validator: (value) => {
          let acceptedValues = ['white', 'brown', 'black']
          return acceptedValues.indexOf(value) !== -1
        },
        description: 'Sidebar background color (white|brown|black)'
      },
      activeColor: {
        type: String,
        default: 'teamwave',
        description: 'Sidebar active text color (primary|info|success|warning|danger)'
      },
      logo: {
        type: String,
        default: '/static/img/logo_team_wave.png',
      },
      logoMini: {
        type: String,
        default: '/static/img/logo_team_wave_mini.png',
      },
      sidebarLinks: {
        type: Array,
        default: () => [],
        description: 'Sidebar links. Can be also provided as children components (sidebar-item)'
      },
      autoClose: {
        type: Boolean,
        default: true
      }
    },
    provide() {
      return {
        autoClose: this.autoClose
      }
    },
    computed: {
      userLinks: function (){

        let checkedPackage = this.sidebarLinks.filter(
                link =>
                        !link.roles
                        && link.package.includes(this.$auth.user.customer.settings.contract.packageType)
                        && link.section == 'user'
        )

        if (this.$auth.user.isOwner || this.$auth.user.isLeader) {
          if (!this.$auth.user.isOwner) {
            checkedPackage = checkedPackage.filter(link => (link.name !== 'News' || (this.$auth.user.permissions.news_publisher === true && link.name === 'News')))
          }
          return checkedPackage
        } else {
          checkedPackage = checkedPackage.filter(link => link.name !== 'My Tasks'
                                                         && (link.name !== 'News' || (this.$auth.user.permissions.news_publisher === true && link.name === 'News')))
          return checkedPackage
        }
      },
      adminLinks: function (){

        let checkedPackage = this.sidebarLinks.filter(
                link =>
                        link.roles
                        && (link.roles && this.$auth.user.roles.some(r => link.roles.includes(r)))
                        && link.package.includes(this.$auth.user.customer.settings.contract.packageType)
                        && link.section == 'admin'
        )

        return checkedPackage
        // return this.sidebarLinks.filter(link => link.roles)
      }
    },
    methods: {
      async initScrollBarAsync () {
        let isWindows = navigator.platform.startsWith('Win');
        if(!isWindows) {
          return;
        }
        const PerfectScroll = await import('perfect-scrollbar')
        PerfectScroll.initialize(this.$refs.sidebarScrollArea)
      }
    },
    mounted () {
      this.initScrollBarAsync()
    },
    beforeDestroy () {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false
      }
    }
  }

</script>
<style>
  @media (min-width: 1000px) {
    .navbar-search-form-mobile,
    .nav-mobile-menu{
      display: none;
    }
  }

  .logo {
    display: flex;
    padding: 0px !important;
    background-color: white;
    height: 74px;
  }

  .logo-mods {
    border-radius: 0px !important;
    padding-left: 10px;
    max-height: 74px;
    margin: auto 0;
  }

  .logo-mini {
    padding-top: 5px;
  }
</style>
